// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v3.12.4
// source: std_msgs.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "std_msgs.proto";

export interface Header {
  stamp:
    | Date
    | undefined;
  /** Can be used for frame_id or other unique identifiers */
  uuid: string;
  /** Sequence ID */
  seq: number;
}

export interface Empty {
}

export interface Bool {
  data: boolean;
}

export interface String {
  data: string;
}

export interface Char {
  data: number;
}

export interface Byte {
  data: number;
}

export interface Int8 {
  data: number;
}

export interface Int16 {
  data: number;
}

export interface Int32 {
  data: number;
}

export interface Int64 {
  data: number;
}

export interface UInt8 {
  data: number;
}

export interface UInt16 {
  data: number;
}

export interface UInt32 {
  data: number;
}

export interface UInt64 {
  data: number;
}

export interface Float32 {
  data: number;
}

export interface Float64 {
  data: number;
}

export interface ColorRGBA {
  r: number;
  g: number;
  b: number;
  a: number;
}

export interface MultiArrayDimension {
  label: string;
  size: number;
  stride: number;
}

export interface MultiArrayLayout {
  dim: MultiArrayDimension[];
  dataOffset: number;
}

export interface Float32MultiArray {
  layout: MultiArrayLayout | undefined;
  data: number[];
}

export interface Float64MultiArray {
  layout: MultiArrayLayout | undefined;
  data: number[];
}

export interface Int8MultiArray {
  layout: MultiArrayLayout | undefined;
  data: number[];
}

export interface Int16MultiArray {
  layout: MultiArrayLayout | undefined;
  data: number[];
}

export interface Int32MultiArray {
  layout: MultiArrayLayout | undefined;
  data: number[];
}

export interface Int64MultiArray {
  layout: MultiArrayLayout | undefined;
  data: number[];
}

export interface UInt8MultiArray {
  layout: MultiArrayLayout | undefined;
  data: number[];
}

export interface UInt16MultiArray {
  layout: MultiArrayLayout | undefined;
  data: number[];
}

export interface UInt32MultiArray {
  layout: MultiArrayLayout | undefined;
  data: number[];
}

export interface UInt64MultiArray {
  layout: MultiArrayLayout | undefined;
  data: number[];
}

export interface ByteMultiArray {
  layout: MultiArrayLayout | undefined;
  data: Uint8Array;
}

function createBaseHeader(): Header {
  return { stamp: undefined, uuid: "", seq: 0 };
}

export const Header: MessageFns<Header> = {
  encode(message: Header, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.stamp !== undefined) {
      Timestamp.encode(toTimestamp(message.stamp), writer.uint32(10).fork()).join();
    }
    if (message.uuid !== "") {
      writer.uint32(18).string(message.uuid);
    }
    if (message.seq !== 0) {
      writer.uint32(24).uint32(message.seq);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Header {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHeader();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.stamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.uuid = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.seq = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Header>, I>>(base?: I): Header {
    return Header.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Header>, I>>(object: I): Header {
    const message = createBaseHeader();
    message.stamp = object.stamp ?? undefined;
    message.uuid = object.uuid ?? "";
    message.seq = object.seq ?? 0;
    return message;
  },
};

function createBaseEmpty(): Empty {
  return {};
}

export const Empty: MessageFns<Empty> = {
  encode(_: Empty, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Empty {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEmpty();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Empty>, I>>(base?: I): Empty {
    return Empty.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Empty>, I>>(_: I): Empty {
    const message = createBaseEmpty();
    return message;
  },
};

function createBaseBool(): Bool {
  return { data: false };
}

export const Bool: MessageFns<Bool> = {
  encode(message: Bool, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== false) {
      writer.uint32(8).bool(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Bool {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBool();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.data = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Bool>, I>>(base?: I): Bool {
    return Bool.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Bool>, I>>(object: I): Bool {
    const message = createBaseBool();
    message.data = object.data ?? false;
    return message;
  },
};

function createBaseString(): String {
  return { data: "" };
}

export const String: MessageFns<String> = {
  encode(message: String, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== "") {
      writer.uint32(10).string(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): String {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseString();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<String>, I>>(base?: I): String {
    return String.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<String>, I>>(object: I): String {
    const message = createBaseString();
    message.data = object.data ?? "";
    return message;
  },
};

function createBaseChar(): Char {
  return { data: 0 };
}

export const Char: MessageFns<Char> = {
  encode(message: Char, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== 0) {
      writer.uint32(8).uint32(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Char {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChar();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.data = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Char>, I>>(base?: I): Char {
    return Char.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Char>, I>>(object: I): Char {
    const message = createBaseChar();
    message.data = object.data ?? 0;
    return message;
  },
};

function createBaseByte(): Byte {
  return { data: 0 };
}

export const Byte: MessageFns<Byte> = {
  encode(message: Byte, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== 0) {
      writer.uint32(8).int32(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Byte {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseByte();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.data = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Byte>, I>>(base?: I): Byte {
    return Byte.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Byte>, I>>(object: I): Byte {
    const message = createBaseByte();
    message.data = object.data ?? 0;
    return message;
  },
};

function createBaseInt8(): Int8 {
  return { data: 0 };
}

export const Int8: MessageFns<Int8> = {
  encode(message: Int8, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== 0) {
      writer.uint32(8).int32(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Int8 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInt8();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.data = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Int8>, I>>(base?: I): Int8 {
    return Int8.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Int8>, I>>(object: I): Int8 {
    const message = createBaseInt8();
    message.data = object.data ?? 0;
    return message;
  },
};

function createBaseInt16(): Int16 {
  return { data: 0 };
}

export const Int16: MessageFns<Int16> = {
  encode(message: Int16, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== 0) {
      writer.uint32(8).int32(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Int16 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInt16();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.data = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Int16>, I>>(base?: I): Int16 {
    return Int16.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Int16>, I>>(object: I): Int16 {
    const message = createBaseInt16();
    message.data = object.data ?? 0;
    return message;
  },
};

function createBaseInt32(): Int32 {
  return { data: 0 };
}

export const Int32: MessageFns<Int32> = {
  encode(message: Int32, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== 0) {
      writer.uint32(8).int32(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Int32 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInt32();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.data = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Int32>, I>>(base?: I): Int32 {
    return Int32.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Int32>, I>>(object: I): Int32 {
    const message = createBaseInt32();
    message.data = object.data ?? 0;
    return message;
  },
};

function createBaseInt64(): Int64 {
  return { data: 0 };
}

export const Int64: MessageFns<Int64> = {
  encode(message: Int64, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== 0) {
      writer.uint32(8).int64(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Int64 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInt64();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.data = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Int64>, I>>(base?: I): Int64 {
    return Int64.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Int64>, I>>(object: I): Int64 {
    const message = createBaseInt64();
    message.data = object.data ?? 0;
    return message;
  },
};

function createBaseUInt8(): UInt8 {
  return { data: 0 };
}

export const UInt8: MessageFns<UInt8> = {
  encode(message: UInt8, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== 0) {
      writer.uint32(8).uint32(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UInt8 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUInt8();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.data = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<UInt8>, I>>(base?: I): UInt8 {
    return UInt8.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UInt8>, I>>(object: I): UInt8 {
    const message = createBaseUInt8();
    message.data = object.data ?? 0;
    return message;
  },
};

function createBaseUInt16(): UInt16 {
  return { data: 0 };
}

export const UInt16: MessageFns<UInt16> = {
  encode(message: UInt16, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== 0) {
      writer.uint32(8).uint32(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UInt16 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUInt16();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.data = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<UInt16>, I>>(base?: I): UInt16 {
    return UInt16.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UInt16>, I>>(object: I): UInt16 {
    const message = createBaseUInt16();
    message.data = object.data ?? 0;
    return message;
  },
};

function createBaseUInt32(): UInt32 {
  return { data: 0 };
}

export const UInt32: MessageFns<UInt32> = {
  encode(message: UInt32, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== 0) {
      writer.uint32(8).uint32(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UInt32 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUInt32();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.data = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<UInt32>, I>>(base?: I): UInt32 {
    return UInt32.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UInt32>, I>>(object: I): UInt32 {
    const message = createBaseUInt32();
    message.data = object.data ?? 0;
    return message;
  },
};

function createBaseUInt64(): UInt64 {
  return { data: 0 };
}

export const UInt64: MessageFns<UInt64> = {
  encode(message: UInt64, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== 0) {
      writer.uint32(8).uint64(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UInt64 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUInt64();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.data = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<UInt64>, I>>(base?: I): UInt64 {
    return UInt64.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UInt64>, I>>(object: I): UInt64 {
    const message = createBaseUInt64();
    message.data = object.data ?? 0;
    return message;
  },
};

function createBaseFloat32(): Float32 {
  return { data: 0 };
}

export const Float32: MessageFns<Float32> = {
  encode(message: Float32, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== 0) {
      writer.uint32(13).float(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Float32 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFloat32();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.data = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Float32>, I>>(base?: I): Float32 {
    return Float32.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Float32>, I>>(object: I): Float32 {
    const message = createBaseFloat32();
    message.data = object.data ?? 0;
    return message;
  },
};

function createBaseFloat64(): Float64 {
  return { data: 0 };
}

export const Float64: MessageFns<Float64> = {
  encode(message: Float64, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== 0) {
      writer.uint32(9).double(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Float64 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFloat64();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.data = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Float64>, I>>(base?: I): Float64 {
    return Float64.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Float64>, I>>(object: I): Float64 {
    const message = createBaseFloat64();
    message.data = object.data ?? 0;
    return message;
  },
};

function createBaseColorRGBA(): ColorRGBA {
  return { r: 0, g: 0, b: 0, a: 0 };
}

export const ColorRGBA: MessageFns<ColorRGBA> = {
  encode(message: ColorRGBA, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.r !== 0) {
      writer.uint32(13).float(message.r);
    }
    if (message.g !== 0) {
      writer.uint32(21).float(message.g);
    }
    if (message.b !== 0) {
      writer.uint32(29).float(message.b);
    }
    if (message.a !== 0) {
      writer.uint32(37).float(message.a);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ColorRGBA {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseColorRGBA();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.r = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.g = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.b = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.a = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ColorRGBA>, I>>(base?: I): ColorRGBA {
    return ColorRGBA.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ColorRGBA>, I>>(object: I): ColorRGBA {
    const message = createBaseColorRGBA();
    message.r = object.r ?? 0;
    message.g = object.g ?? 0;
    message.b = object.b ?? 0;
    message.a = object.a ?? 0;
    return message;
  },
};

function createBaseMultiArrayDimension(): MultiArrayDimension {
  return { label: "", size: 0, stride: 0 };
}

export const MultiArrayDimension: MessageFns<MultiArrayDimension> = {
  encode(message: MultiArrayDimension, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.label !== "") {
      writer.uint32(10).string(message.label);
    }
    if (message.size !== 0) {
      writer.uint32(16).uint32(message.size);
    }
    if (message.stride !== 0) {
      writer.uint32(24).uint32(message.stride);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MultiArrayDimension {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMultiArrayDimension();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.label = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.size = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.stride = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<MultiArrayDimension>, I>>(base?: I): MultiArrayDimension {
    return MultiArrayDimension.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MultiArrayDimension>, I>>(object: I): MultiArrayDimension {
    const message = createBaseMultiArrayDimension();
    message.label = object.label ?? "";
    message.size = object.size ?? 0;
    message.stride = object.stride ?? 0;
    return message;
  },
};

function createBaseMultiArrayLayout(): MultiArrayLayout {
  return { dim: [], dataOffset: 0 };
}

export const MultiArrayLayout: MessageFns<MultiArrayLayout> = {
  encode(message: MultiArrayLayout, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.dim) {
      MultiArrayDimension.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.dataOffset !== 0) {
      writer.uint32(16).uint32(message.dataOffset);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MultiArrayLayout {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMultiArrayLayout();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dim.push(MultiArrayDimension.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.dataOffset = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<MultiArrayLayout>, I>>(base?: I): MultiArrayLayout {
    return MultiArrayLayout.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MultiArrayLayout>, I>>(object: I): MultiArrayLayout {
    const message = createBaseMultiArrayLayout();
    message.dim = object.dim?.map((e) => MultiArrayDimension.fromPartial(e)) || [];
    message.dataOffset = object.dataOffset ?? 0;
    return message;
  },
};

function createBaseFloat32MultiArray(): Float32MultiArray {
  return { layout: undefined, data: [] };
}

export const Float32MultiArray: MessageFns<Float32MultiArray> = {
  encode(message: Float32MultiArray, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.layout !== undefined) {
      MultiArrayLayout.encode(message.layout, writer.uint32(10).fork()).join();
    }
    writer.uint32(18).fork();
    for (const v of message.data) {
      writer.float(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Float32MultiArray {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFloat32MultiArray();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.layout = MultiArrayLayout.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag === 21) {
            message.data.push(reader.float());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.data.push(reader.float());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Float32MultiArray>, I>>(base?: I): Float32MultiArray {
    return Float32MultiArray.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Float32MultiArray>, I>>(object: I): Float32MultiArray {
    const message = createBaseFloat32MultiArray();
    message.layout = (object.layout !== undefined && object.layout !== null)
      ? MultiArrayLayout.fromPartial(object.layout)
      : undefined;
    message.data = object.data?.map((e) => e) || [];
    return message;
  },
};

function createBaseFloat64MultiArray(): Float64MultiArray {
  return { layout: undefined, data: [] };
}

export const Float64MultiArray: MessageFns<Float64MultiArray> = {
  encode(message: Float64MultiArray, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.layout !== undefined) {
      MultiArrayLayout.encode(message.layout, writer.uint32(10).fork()).join();
    }
    writer.uint32(18).fork();
    for (const v of message.data) {
      writer.double(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Float64MultiArray {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFloat64MultiArray();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.layout = MultiArrayLayout.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag === 17) {
            message.data.push(reader.double());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.data.push(reader.double());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Float64MultiArray>, I>>(base?: I): Float64MultiArray {
    return Float64MultiArray.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Float64MultiArray>, I>>(object: I): Float64MultiArray {
    const message = createBaseFloat64MultiArray();
    message.layout = (object.layout !== undefined && object.layout !== null)
      ? MultiArrayLayout.fromPartial(object.layout)
      : undefined;
    message.data = object.data?.map((e) => e) || [];
    return message;
  },
};

function createBaseInt8MultiArray(): Int8MultiArray {
  return { layout: undefined, data: [] };
}

export const Int8MultiArray: MessageFns<Int8MultiArray> = {
  encode(message: Int8MultiArray, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.layout !== undefined) {
      MultiArrayLayout.encode(message.layout, writer.uint32(10).fork()).join();
    }
    writer.uint32(18).fork();
    for (const v of message.data) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Int8MultiArray {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInt8MultiArray();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.layout = MultiArrayLayout.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.data.push(reader.int32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.data.push(reader.int32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Int8MultiArray>, I>>(base?: I): Int8MultiArray {
    return Int8MultiArray.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Int8MultiArray>, I>>(object: I): Int8MultiArray {
    const message = createBaseInt8MultiArray();
    message.layout = (object.layout !== undefined && object.layout !== null)
      ? MultiArrayLayout.fromPartial(object.layout)
      : undefined;
    message.data = object.data?.map((e) => e) || [];
    return message;
  },
};

function createBaseInt16MultiArray(): Int16MultiArray {
  return { layout: undefined, data: [] };
}

export const Int16MultiArray: MessageFns<Int16MultiArray> = {
  encode(message: Int16MultiArray, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.layout !== undefined) {
      MultiArrayLayout.encode(message.layout, writer.uint32(10).fork()).join();
    }
    writer.uint32(18).fork();
    for (const v of message.data) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Int16MultiArray {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInt16MultiArray();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.layout = MultiArrayLayout.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.data.push(reader.int32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.data.push(reader.int32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Int16MultiArray>, I>>(base?: I): Int16MultiArray {
    return Int16MultiArray.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Int16MultiArray>, I>>(object: I): Int16MultiArray {
    const message = createBaseInt16MultiArray();
    message.layout = (object.layout !== undefined && object.layout !== null)
      ? MultiArrayLayout.fromPartial(object.layout)
      : undefined;
    message.data = object.data?.map((e) => e) || [];
    return message;
  },
};

function createBaseInt32MultiArray(): Int32MultiArray {
  return { layout: undefined, data: [] };
}

export const Int32MultiArray: MessageFns<Int32MultiArray> = {
  encode(message: Int32MultiArray, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.layout !== undefined) {
      MultiArrayLayout.encode(message.layout, writer.uint32(10).fork()).join();
    }
    writer.uint32(18).fork();
    for (const v of message.data) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Int32MultiArray {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInt32MultiArray();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.layout = MultiArrayLayout.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.data.push(reader.int32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.data.push(reader.int32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Int32MultiArray>, I>>(base?: I): Int32MultiArray {
    return Int32MultiArray.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Int32MultiArray>, I>>(object: I): Int32MultiArray {
    const message = createBaseInt32MultiArray();
    message.layout = (object.layout !== undefined && object.layout !== null)
      ? MultiArrayLayout.fromPartial(object.layout)
      : undefined;
    message.data = object.data?.map((e) => e) || [];
    return message;
  },
};

function createBaseInt64MultiArray(): Int64MultiArray {
  return { layout: undefined, data: [] };
}

export const Int64MultiArray: MessageFns<Int64MultiArray> = {
  encode(message: Int64MultiArray, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.layout !== undefined) {
      MultiArrayLayout.encode(message.layout, writer.uint32(10).fork()).join();
    }
    writer.uint32(18).fork();
    for (const v of message.data) {
      writer.int64(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Int64MultiArray {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInt64MultiArray();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.layout = MultiArrayLayout.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.data.push(longToNumber(reader.int64()));

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.data.push(longToNumber(reader.int64()));
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Int64MultiArray>, I>>(base?: I): Int64MultiArray {
    return Int64MultiArray.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Int64MultiArray>, I>>(object: I): Int64MultiArray {
    const message = createBaseInt64MultiArray();
    message.layout = (object.layout !== undefined && object.layout !== null)
      ? MultiArrayLayout.fromPartial(object.layout)
      : undefined;
    message.data = object.data?.map((e) => e) || [];
    return message;
  },
};

function createBaseUInt8MultiArray(): UInt8MultiArray {
  return { layout: undefined, data: [] };
}

export const UInt8MultiArray: MessageFns<UInt8MultiArray> = {
  encode(message: UInt8MultiArray, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.layout !== undefined) {
      MultiArrayLayout.encode(message.layout, writer.uint32(10).fork()).join();
    }
    writer.uint32(18).fork();
    for (const v of message.data) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UInt8MultiArray {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUInt8MultiArray();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.layout = MultiArrayLayout.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.data.push(reader.uint32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.data.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<UInt8MultiArray>, I>>(base?: I): UInt8MultiArray {
    return UInt8MultiArray.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UInt8MultiArray>, I>>(object: I): UInt8MultiArray {
    const message = createBaseUInt8MultiArray();
    message.layout = (object.layout !== undefined && object.layout !== null)
      ? MultiArrayLayout.fromPartial(object.layout)
      : undefined;
    message.data = object.data?.map((e) => e) || [];
    return message;
  },
};

function createBaseUInt16MultiArray(): UInt16MultiArray {
  return { layout: undefined, data: [] };
}

export const UInt16MultiArray: MessageFns<UInt16MultiArray> = {
  encode(message: UInt16MultiArray, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.layout !== undefined) {
      MultiArrayLayout.encode(message.layout, writer.uint32(10).fork()).join();
    }
    writer.uint32(18).fork();
    for (const v of message.data) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UInt16MultiArray {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUInt16MultiArray();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.layout = MultiArrayLayout.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.data.push(reader.uint32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.data.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<UInt16MultiArray>, I>>(base?: I): UInt16MultiArray {
    return UInt16MultiArray.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UInt16MultiArray>, I>>(object: I): UInt16MultiArray {
    const message = createBaseUInt16MultiArray();
    message.layout = (object.layout !== undefined && object.layout !== null)
      ? MultiArrayLayout.fromPartial(object.layout)
      : undefined;
    message.data = object.data?.map((e) => e) || [];
    return message;
  },
};

function createBaseUInt32MultiArray(): UInt32MultiArray {
  return { layout: undefined, data: [] };
}

export const UInt32MultiArray: MessageFns<UInt32MultiArray> = {
  encode(message: UInt32MultiArray, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.layout !== undefined) {
      MultiArrayLayout.encode(message.layout, writer.uint32(10).fork()).join();
    }
    writer.uint32(18).fork();
    for (const v of message.data) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UInt32MultiArray {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUInt32MultiArray();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.layout = MultiArrayLayout.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.data.push(reader.uint32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.data.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<UInt32MultiArray>, I>>(base?: I): UInt32MultiArray {
    return UInt32MultiArray.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UInt32MultiArray>, I>>(object: I): UInt32MultiArray {
    const message = createBaseUInt32MultiArray();
    message.layout = (object.layout !== undefined && object.layout !== null)
      ? MultiArrayLayout.fromPartial(object.layout)
      : undefined;
    message.data = object.data?.map((e) => e) || [];
    return message;
  },
};

function createBaseUInt64MultiArray(): UInt64MultiArray {
  return { layout: undefined, data: [] };
}

export const UInt64MultiArray: MessageFns<UInt64MultiArray> = {
  encode(message: UInt64MultiArray, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.layout !== undefined) {
      MultiArrayLayout.encode(message.layout, writer.uint32(10).fork()).join();
    }
    writer.uint32(18).fork();
    for (const v of message.data) {
      writer.uint64(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UInt64MultiArray {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUInt64MultiArray();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.layout = MultiArrayLayout.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.data.push(longToNumber(reader.uint64()));

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.data.push(longToNumber(reader.uint64()));
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<UInt64MultiArray>, I>>(base?: I): UInt64MultiArray {
    return UInt64MultiArray.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UInt64MultiArray>, I>>(object: I): UInt64MultiArray {
    const message = createBaseUInt64MultiArray();
    message.layout = (object.layout !== undefined && object.layout !== null)
      ? MultiArrayLayout.fromPartial(object.layout)
      : undefined;
    message.data = object.data?.map((e) => e) || [];
    return message;
  },
};

function createBaseByteMultiArray(): ByteMultiArray {
  return { layout: undefined, data: new Uint8Array(0) };
}

export const ByteMultiArray: MessageFns<ByteMultiArray> = {
  encode(message: ByteMultiArray, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.layout !== undefined) {
      MultiArrayLayout.encode(message.layout, writer.uint32(10).fork()).join();
    }
    if (message.data.length !== 0) {
      writer.uint32(18).bytes(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ByteMultiArray {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseByteMultiArray();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.layout = MultiArrayLayout.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ByteMultiArray>, I>>(base?: I): ByteMultiArray {
    return ByteMultiArray.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ByteMultiArray>, I>>(object: I): ByteMultiArray {
    const message = createBaseByteMultiArray();
    message.layout = (object.layout !== undefined && object.layout !== null)
      ? MultiArrayLayout.fromPartial(object.layout)
      : undefined;
    message.data = object.data ?? new Uint8Array(0);
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
